// Currently setting this to empty string, may in future we will have 'v-' prefix.
// const URL_VARIABLE_PREFIX = '';
export const VARIABLE_PREFIX = "$";
export const GLOBAL_VARIABLE_SRV_KEY = "globalVarSrv";
